import config from 'src/config';
import { postRequest, getRequest, patchRequest } from 'src/utils/RequestUtil';

export const dataCenterCreateAPI = function (data) {
    const url = `${config.baseUrl}dataCenter/create`;
    return postRequest({
        url,
        data,
    });
};

export const dataCenterListAPI = function () {
    const url = `${config.baseUrl}dataCenter/list`;
    return postRequest({
        url,
    });
};

export const fileHistoryAPI = function (dataCenterId) {
    console.log('dataCenterId', dataCenterId)
    const url = `${config.baseUrl}datacenter/file-history?dataCenterId=${dataCenterId}`;
    return getRequest({
        url,
    });
};

export const uploadFileFromSheetsAPI = function (data) {
    const url = `${config.baseUrl}dataCenter/file`;
    return postRequest({
        url,
        data,
    });
};

export const saveFileHeaderAPI = function (data) {
    const url = `${config.baseUrl}dataCenter/headers`;
    return postRequest({
        url,
        data,
    });
};

export const getFileHeadersAPI = function (data) {
    console.log('data', data)
    const url = `${config.baseUrl}dataCenter/file-header`;
    return postRequest({
        url,
        data,
    });
};

export const fileRecordsAPI = function (data) {
    const url = `${config.baseUrl}datacenter/records`;
    return postRequest({
        url,
        data
    });
};

export const fileRestoreAPI = function (data) {
    const url = `${config.baseUrl}datacenter/restore`;
    return postRequest({
        url,
        data
    });
};

export const viewHistoryRecordsAPI = function (data) {
    console.log('data', data)
    const url = `${config.baseUrl}datacenter/read-csv-from-s3`;
    return postRequest({
        url,
        data
    });
};

export const getRecentFileDataAPI = function (dataCenterId) {
    const url = `${config.baseUrl}datacenter/latest/${dataCenterId}`;
    return getRequest({
        url
    });
};

export const updateFileHeaderAPI = function (fileHeaderId, data) {
    const url = `${config.baseUrl}datacenter/file-header/${fileHeaderId}`;
    return patchRequest({
        url,
        data
    });
};

export const updateUidHeaderAPI = function (fileHeaderId, data) {
    const url = `${config.baseUrl}datacenter/file-header/uid/${fileHeaderId}`;
    return patchRequest({
        url,
        data
    });
};

export const getFileHeaderIdAPI = function (fileHeaderId, fieldName) {
    const url = `${config.baseUrl}datacenter/file-header/${fileHeaderId}?fieldName=${fieldName}`;
    return getRequest({
        url
    });
};